import { UploadFile, PersonAdd } from '@mui/icons-material';
import { Grid, Tooltip, Button, Paper } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { ComposeEmailModal } from 'src/modules/groupMessageEmail/components/composeEmailModal';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useMemberContext } from 'src/shared/contexts/memberContext';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { useGlobals } from 'src/shared/contexts/appContext';
import { MemberCreateModal } from '../components/memberCreateModal';
import { MemberEditModal } from '../components/memberEditModal';
import { MemberCreateInvoice } from '../components/memberCreateInvoice';

export const MembersPage = () => {
  const { t } = useTranslation(['members']);
  const {
    createMode,
    setCreateMode,
    editMode,
    setEditMode,
    composeEmailMode,
    setComposeEmailMode,
    editMember,
    setEditMember,
    createInvoiceMode,
    setCreateInvoiceMode,
    selectedMembers,
    setSelectedMembers,
  } = useMemberContext();
  const { currentUser } = useGlobals();

  const handleCloseComposeEmailModal = useCallback(() => {
    setSelectedMembers([]);
    setComposeEmailMode(false);
  }, [setComposeEmailMode, setSelectedMembers]);

  const memberPageTabs: PageTabItem[] = [
    {
      label: 'member:memberTabNavigation.overview',
      route: RoutesEnum.Members,
    },
    {
      label: 'member:memberTabNavigation.advancedSearch',
      route: RoutesEnum.MemberAdvancedSearch,
    },
    {
      label: 'member:memberTabNavigation.selections',
      route: RoutesEnum.MemberSelection,
    },
  ];

  const hasCreateMemberPermission = getPermission(currentUser, PermissionEnum.MemberCreate);

  return (
    <>
      <GridWrapper>
        <Grid item xs={12} md={4}>
          <MainContentHeader title={t('member:listMemberHeader')} />
        </Grid>
        <Grid item xs={12} md={8} style={{ display: 'flex', justifyContent: 'flex-end', gridColumnGap: '5px' }}>
          <Tooltip arrow title={`${t('common:sideMenu.comingSoon')}`}>
            <span>
              <Button
                component={Link as any}
                to={RoutesEnum.ImportMembers}
                variant='contained'
                color='secondary'
                startIcon={<UploadFile />}
                disableElevation
                disabled
              >
                {t('member:importMember.import')}
              </Button>
            </span>
          </Tooltip>
          <Button
            onClick={() => setCreateMode(true)}
            disabled={!hasCreateMemberPermission}
            variant='contained'
            color='secondary'
            startIcon={<PersonAdd />}
            disableElevation
          >
            {t('member:memberUpdateTypeEnum.NewMember')}
          </Button>
        </Grid>
        <Grid item xs={12} sx={{ mb: 0 }} />
      </GridWrapper>
      <GridWrapper>
        <Grid item xs={12}>
          <Paper>
            <PageTabNavigation pageTabs={memberPageTabs} />
            <Outlet />
          </Paper>
        </Grid>
      </GridWrapper>
      {createMode && (
        <MemberCreateModal otherContactMode={false} onClose={() => setCreateMode(false)} onSave={() => setCreateMode(false)} modalOpen={createMode} />
      )}
      {composeEmailMode && selectedMembers && !!selectedMembers.length && (
        <ComposeEmailModal
          members={selectedMembers}
          onClose={handleCloseComposeEmailModal}
          // onSave={handleCloseComposeEmailModal} // Not used
          modalOpen={selectedMembers && !!selectedMembers.length}
        />
      )}
      {editMember && editMode && (
        <MemberEditModal
          otherContactMode={false}
          member={editMember}
          onClose={() => {
            setEditMember(undefined);
            setEditMode(false);
            // fetchData(member.member_id.toString());
          }}
          onSave={() => {
            ConsoleHelper.log('onSave');
            // fetchData(member.member_id.toString());
          }}
          callback={() => {
            ConsoleHelper.log('Profiler uppdaterade på en medlem');
          }}
          modalOpen={editMode}
        />
      )}
      {createInvoiceMode && selectedMembers && !!selectedMembers.length && (
        <MemberCreateInvoice
          otherContactMode={false}
          members={selectedMembers}
          onClose={() => setCreateInvoiceMode(false)}
          onSave={() => setCreateInvoiceMode(false)}
          modalOpen={selectedMembers && !!selectedMembers.length}
        />
      )}
    </>
  );
};
